import React from 'react';
import { TypedMemo } from '../../../common/types';
import { LoadingView } from '../../../common/views/LoadingView';
import { useAccountId } from '../../../../redux/slices/appInfo/hooks';
import { ChannelsBody } from '../../../music24/promote/channels/ChannelsBody';
/* eslint-disable css-modules/no-unused-class -- the stylesheet of the Promote pillar; this tab uses its panel stack */
import promoteStyles from '../../../music24/promote/Promote.module.scss';
/* eslint-enable css-modules/no-unused-class */

/**
 * Settings → Connections (navigation v2, design f 6b): the old Channels page body with no change.
 * The settings page head names the tab; every call is account-scoped.
 */
const ConnectionsTabComponent: React.FC = () => {
  const accountId = useAccountId();

  if (accountId === null) {
    return <LoadingView />;
  }

  return (
    <div className={promoteStyles.panelStack}>
      <ChannelsBody accountId={accountId} />
    </div>
  );
};

export const ConnectionsTab = TypedMemo(ConnectionsTabComponent);
